import { type Suite } from "#gen/bundles/v1/bundle_pb.js";
import { type Folder } from "#gen/folder/v1/folders_pb.js";
import type { StaticAsset } from "#gen/staticassets/v1/static_assets_pb.js";

export type Bulkable = Suite | Folder | StaticAsset;

export function isSuite(asset: Bulkable): asset is Suite {
	return asset.$typeName === "bundles.v1.Suite";
}

export function isFolder(asset: Bulkable): asset is Folder {
	return asset.$typeName === "folder.v1.Folder";
}

export function isFlowListCompatible(asset: Bulkable): asset is Suite | Folder {
	return isSuite(asset) || isFolder(asset);
}

export function isStaticAsset(asset: Bulkable): asset is StaticAsset {
	return asset.$typeName === "staticassets.v1.StaticAsset";
}
